import React, { useState } from 'react'
import styles from './confirmCodeField.module.scss'
import ErrorIcon from '../../../icons/errorIcon.svg'
import { useTranslation } from 'react-i18next'
import cx from 'classnames'
import { NUMBER_REGEXP } from '../../../constant/constants'
import { useDispatch } from 'react-redux'
import isNumber from '../../../utils/validators/isNumber'
import { setVerificationCode } from '../../../redux/actions/authActions'
import { setSignInWithEmailFormValidation } from '../../../redux/actions/validation'

const ConfirmCodeField = ({
  verificationCode,
  errorMessage: error,
  setVerification,
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [errorMessage, setErrorMessage] = useState('')
  const handleChange = (e) => {
    if (
      (isNumber(e.currentTarget.value) || e.currentTarget.value === '') &&
      e.currentTarget.value.length <= 6 &&
      !e.currentTarget.value.includes('e') &&
      !e.currentTarget.value.includes('E')
    ) {
      dispatch(setVerificationCode(e.currentTarget.value))
      if (e.currentTarget.value.length === 6) {
        e.currentTarget.blur()
      }
    }
    dispatch(setVerificationCode(e.currentTarget.value))
  }
  const handleBlurCodeField = (field, value, e) => {
    if (e?.relatedTarget?.type !== 'submit') {
      setErrorMessage('')
      validationCode(field, value)
    }
  }
  const validationCode = (field, value) => {
    let inValid = false
    if (!value.trim()) {
      inValid = true
      dispatch(
        setSignInWithEmailFormValidation(field + 'Err', 'Code ist erforderlich'),
      )
    } else if (value.trim().length !== 6) {
      inValid = true
      dispatch(setSignInWithEmailFormValidation(field + 'Err', ' Code ist ungültig'))
    }
    return inValid
  }
  const message =
    typeof errorMessage === 'object'
      ? errorMessage.map((e) => t(e)).join(', ')
      : t(errorMessage)
  return (
    <>
      <input
        className={cx(styles.confirmCodeField, {
          [styles.invalidInput]: errorMessage,
        })}
        placeholder={'------'}
        maxLength="6"
        onChange={handleChange}
        onBlur={(e) =>
          handleBlurCodeField('verificationCode', e.currentTarget.value, e)
        }
        value={verificationCode}
      />
      {error && (
        <div className={styles.errorMessage}>
          <img src={ErrorIcon} alt={ErrorIcon} />
          <span>{error}</span>
        </div>
      )}
    </>
  )
}

export default ConfirmCodeField
